import React from 'react';
import fhirpath from 'fhirpath';
import { PassoExecutado } from '@/models/PassoExecutado';

import { ArtifactFormOverrides } from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';
import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';

import { useEnterpriseContext } from '@/features/enterprise/contexts/EnterpriseContext';

import { Paragraph } from '@/features/artifacts/components/ArtifactForm/ArtifactField.widgets';
import { Procedimento } from '@/models/Solicitacao';
import CardSolicitacao, {
  CardSolicitacaoProxyProps,
} from '../../CardSolicitacao';
import SolicitacaoList from '..';
import { useSolicitacoesContext } from '../../../providers/SolicitacoesProvider.index';
import CardSharedDevices from '../../CardSharedDevices';
import {
  containsDevices,
  SharedDevices,
} from '../../CardSharedDevices/helpers';

// import { Container } from './styles';
const Form: ArtifactFormOverrides = [
  {
    name: 'reasonCode',
    label: 'Indicação Clínica',
    required: true,
    containerStyle: { flex: '0 1 100%' },
  },
  {
    name: 'note',
    label: 'Observações',
    widget: Paragraph,
    containerStyle: { flex: '0 1 100%' },
  },
];

const CardProcedimento: React.FC<CardSolicitacaoProxyProps> = ({
  solicitacao,
  ...rest
}) => {
  const form = useArtifactFormConfig('procedimento', Form);

  const title = React.useMemo(() => {
    return fhirpath.evaluate(
      solicitacao.pedido,
      'ServiceRequest.code.text | ServiceRequest.code.coding.display',
    )[0];
  }, [solicitacao.pedido]);

  const description = React.useMemo(() => {
    const reason = fhirpath.evaluate(
      solicitacao.pedido,
      'ServiceRequest.reasonCode.select(text | coding.display).first()',
    );
    if (reason.length) {
      return reason[0];
    }

    return '';
  }, [solicitacao.pedido]);

  return (
    <CardSolicitacao
      title={title}
      description={description}
      solicitacao={solicitacao}
      form={form}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
};
interface Props {
  passo: PassoExecutado;
}
const SolicitacaoListProcedimento: React.FC<Props> = ({ passo }) => {
  const { list, changeSharedDevices } = useSolicitacoesContext();
  const [{ mode }] = useEnterpriseContext();

  const handleSharedDevicesChange = React.useCallback(
    (shared: SharedDevices[]) => {
      changeSharedDevices({ source: passo.id, shared });
    },
    [changeSharedDevices, passo],
  );

  const states = React.useMemo(() => {
    return list({ tipo: 'procedimento', source: passo.id });
  }, [list, passo]);

  const selectedProcedimentos = React.useMemo(() => {
    return states
      .filter(state => state.selected)
      .map(state => state.solicitacao as Procedimento);
  }, [states]);

  const procedimentos = React.useMemo(() => {
    return states.map(state => state.solicitacao as Procedimento);
  }, [states]);

  const canEditDevices = React.useMemo(() => {
    return mode !== 'not_integrated' && !passo.executado;
  }, [mode, passo.executado]);

  return (
    <SolicitacaoList
      tipo="procedimento"
      passo={passo}
      CardSolicitacaoComponent={CardProcedimento}
      groupTitle="Selecione os procedimentos que você deseja solicitar no seu prontuário"
      addConfig={{
        title: 'Adicionar procedimento complementar',
      }}
    >
      {containsDevices(procedimentos.map(p => p.pedido)) && (
        <CardSharedDevices
          procedimentos={selectedProcedimentos}
          onSharedDevicesChange={handleSharedDevicesChange}
          disabled={!canEditDevices}
        />
      )}
    </SolicitacaoList>
  );
};

export default SolicitacaoListProcedimento;
